import { reactive } from 'vue';
export const i18nConfigStore = reactive({
    language: '',
    langMaps: {}
});
